import {Component, EventEmitter, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PropertyDictionaryInf} from '../../../interfaces/users/property-dictionary-inf';

export interface PropertyDictionaryDialog {
  attributes: PropertyDictionaryInf[];
  selectedItem: PropertyDictionaryInf;
  isEditMode?: boolean;
}

@Component({
  selector: 'properties-dictionary-dialog',
  templateUrl: './properties-dictionary-dialog.component.html',
  styleUrls: ['./properties-dictionary-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PropertiesDictionaryDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<PropertiesDictionaryDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: PropertyDictionaryDialog) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();

  defaultPropertyDictionary: PropertyDictionaryInf = {
    combinationDelimiter: '',
    combinationPropertyId1: undefined,
    combinationPropertyId2: undefined,
    description: '',
    dialable: false,
    isCombined: false,
    name: '',
    normalizeCombinedProperty: '',
    primary: true
  };

  ngOnInit(): void {
    if (!this.data.isEditMode) {
      this.data.selectedItem = this.defaultPropertyDictionary;
    }
    this.data.attributes = this.data.attributes.filter((attr) =>  attr.name !== this.data.selectedItem.name);
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    if (!this.data.selectedItem.isCombined){
      delete this.data.selectedItem.combinationPropertyId1;
      delete this.data.selectedItem.combinationPropertyId2;
      delete this.data.selectedItem.combinationDelimiter;
    }
    this.onApply.emit(this.data.selectedItem);
  }
}
